//Belongs to JobPosting Entity
export const JobPostingStatusEnum = Object.freeze({
  Open: 0,
  Draft: 1,
  OnHold: 2,
  Filled: 3,
  Canceled: 4,
});

//  Helper functions
export function getStatusKey(statusValue) {
  return Object.keys(JobPostingStatusEnum).find((key) => JobPostingStatusEnum[key] === statusValue);
}
